// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuillInput_quillContainer__lO1yp {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.QuillInput_headerRow__mLLgr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.QuillInput_label__pZegQ {
  color: var(--black-color);
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 0;
}

.QuillInput_attachPdfBtn__ZkSQE {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.QuillInput_attachPdfBtn__ZkSQE:hover:not(:disabled) {
  background-color: #ffe4e6;
  border-color: #fda4af;
  color: #be123c;
  transform: translateY(-1px);
}

.QuillInput_attachPdfBtn__ZkSQE:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.QuillInput_pdfIcon__f1ggR {
  color: #e11d48;
}

.QuillInput_progressContainer__LVRvJ {
  width: 100%;
  height: 5px;
  background-color: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 2px;
}

.QuillInput_progressBar__NH1Ax {
  height: 100%;
  background: linear-gradient(90deg, #e11d48, #f43f5e);
  transition: width 0.3s ease;
}

.QuillInput_quillInput__nQbVJ {
  border-radius: 8px;
  border: 2px solid rgba(142, 142, 142, 0.45);
  background: #ffffff;
}

.QuillInput_quillInput__nQbVJ > div > div:nth-child(1) {
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
  border: none;
  border-bottom: 1px solid rgba(142, 142, 142, 0.25);
  background-color: #f8fafc;
}

.QuillInput_quillInput__nQbVJ > div > div:nth-child(2) {
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
  height: calc(100% - 42px);
  min-height: 160px;
  overflow-y: auto;
  border: none;
}

.QuillInput_errorText__ArVjW {
  font-size: 13px;
}

/* Positioning & Styling Modal */
.QuillInput_configModal__RUDwK .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.QuillInput_modalHeader__2wj0E {
  padding: 18px 24px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.QuillInput_closeBtn__bp4GX {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.QuillInput_closeBtn__bp4GX:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.QuillInput_modalBody__yyptQ {
  padding: 24px;
  background-color: #ffffff;
  max-height: 75vh;
  overflow-y: auto;
}

.QuillInput_modalFooter__PzsY0 {
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.QuillInput_sectionLabel__Rcp0W {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.QuillInput_customInput__fOR1C {
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.QuillInput_customInput__fOR1C:focus {
  border-color: #15803d;
  box-shadow: 0 0 0 3px rgba(21, 128, 61, 0.12);
}

.QuillInput_optionGroup__RoG5I {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.QuillInput_optionCard__jnm-7 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 14px;
  background-color: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
}

.QuillInput_optionCard__jnm-7:hover {
  border-color: #94a3b8;
  background-color: #f1f5f9;
}

.QuillInput_alignmentGroup__7\\+pxS {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.QuillInput_alignCard__riSrg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px;
  background-color: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s;
}

.QuillInput_alignCard__riSrg:hover {
  border-color: #94a3b8;
  background-color: #f1f5f9;
}

.QuillInput_styleCard__SOwRh {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 10px;
  height: 100%;
  background-color: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.QuillInput_styleCard__SOwRh:hover {
  border-color: #94a3b8;
  background-color: #f1f5f9;
}

.QuillInput_activeOption__RrH79 {
  border-color: #15803d !important;
  background-color: #f0fdf4 !important;
  color: #15803d !important;
  box-shadow: 0 0 0 2px rgba(21, 128, 61, 0.2);
}

.QuillInput_actionBtnsGroup__oCsF7 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.QuillInput_editPdfBtn__\\+w-dL {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.QuillInput_editPdfBtn__\\+w-dL:hover:not(:disabled) {
  background-color: #dbeafe;
  border-color: #93c5fd;
  color: #1d4ed8;
  transform: translateY(-1px);
}

.QuillInput_editPdfBtn__\\+w-dL:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.QuillInput_pdfSelectBox__OfRqZ {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
  background-color: #f8fafc;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  width: 100%;
  outline: none;
}

.QuillInput_pdfSelectBox__OfRqZ:focus {
  border-color: #2563eb;
  background-color: #ffffff;
}

.QuillInput_deleteBtn__oDGLP {
  background-color: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  cursor: pointer;
}

.QuillInput_deleteBtn__oDGLP:hover {
  background-color: #ffe4e6;
  border-color: #fda4af;
  color: #be123c;
}

.QuillInput_previewContainer__rcwwP {
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 20px;
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}


`, "",{"version":3,"sources":["webpack://./src/Components/organisms/QuillInput/QuillInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,YAAY;EACZ,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,YAAY;EACZ,qFAAqF;AACvF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".quillContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.headerRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.label {\n  color: var(--black-color);\n  text-transform: capitalize;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.attachPdfBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #fff1f2;\n  color: #e11d48;\n  border: 1px solid #fecdd3;\n  padding: 5px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.attachPdfBtn:hover:not(:disabled) {\n  background-color: #ffe4e6;\n  border-color: #fda4af;\n  color: #be123c;\n  transform: translateY(-1px);\n}\n\n.attachPdfBtn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.pdfIcon {\n  color: #e11d48;\n}\n\n.progressContainer {\n  width: 100%;\n  height: 5px;\n  background-color: #e2e8f0;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-top: 2px;\n}\n\n.progressBar {\n  height: 100%;\n  background: linear-gradient(90deg, #e11d48, #f43f5e);\n  transition: width 0.3s ease;\n}\n\n.quillInput {\n  border-radius: 8px;\n  border: 2px solid rgba(142, 142, 142, 0.45);\n  background: #ffffff;\n}\n\n.quillInput > div > div:nth-child(1) {\n  border-top-left-radius: 6px !important;\n  border-top-right-radius: 6px !important;\n  border: none;\n  border-bottom: 1px solid rgba(142, 142, 142, 0.25);\n  background-color: #f8fafc;\n}\n\n.quillInput > div > div:nth-child(2) {\n  border-bottom-left-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n  height: calc(100% - 42px);\n  min-height: 160px;\n  overflow-y: auto;\n  border: none;\n}\n\n.errorText {\n  font-size: 13px;\n}\n\n/* Positioning & Styling Modal */\n.configModal :global(.modal-content) {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.modalHeader {\n  padding: 18px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.closeBtn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.modalBody {\n  padding: 24px;\n  background-color: #ffffff;\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n.modalFooter {\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.sectionLabel {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.customInput {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1.5px solid #cbd5e1;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.customInput:focus {\n  border-color: #15803d;\n  box-shadow: 0 0 0 3px rgba(21, 128, 61, 0.12);\n}\n\n.optionGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.optionCard {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 10px 14px;\n  background-color: #f8fafc;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s;\n}\n\n.optionCard:hover {\n  border-color: #94a3b8;\n  background-color: #f1f5f9;\n}\n\n.alignmentGroup {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.alignCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 10px;\n  background-color: #f8fafc;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.alignCard:hover {\n  border-color: #94a3b8;\n  background-color: #f1f5f9;\n}\n\n.styleCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 14px 10px;\n  height: 100%;\n  background-color: #f8fafc;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.styleCard:hover {\n  border-color: #94a3b8;\n  background-color: #f1f5f9;\n}\n\n.activeOption {\n  border-color: #15803d !important;\n  background-color: #f0fdf4 !important;\n  color: #15803d !important;\n  box-shadow: 0 0 0 2px rgba(21, 128, 61, 0.2);\n}\n\n.actionBtnsGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.editPdfBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #eff6ff;\n  color: #2563eb;\n  border: 1px solid #bfdbfe;\n  padding: 5px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.editPdfBtn:hover:not(:disabled) {\n  background-color: #dbeafe;\n  border-color: #93c5fd;\n  color: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.editPdfBtn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.pdfSelectBox {\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1.5px solid #cbd5e1;\n  background-color: #f8fafc;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  width: 100%;\n  outline: none;\n}\n\n.pdfSelectBox:focus {\n  border-color: #2563eb;\n  background-color: #ffffff;\n}\n\n.deleteBtn {\n  background-color: #fff1f2;\n  color: #e11d48;\n  border: 1px solid #fecdd3;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.deleteBtn:hover {\n  background-color: #ffe4e6;\n  border-color: #fda4af;\n  color: #be123c;\n}\n\n.previewContainer {\n  background-color: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 10px;\n  padding: 20px;\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quillContainer": `QuillInput_quillContainer__lO1yp`,
	"headerRow": `QuillInput_headerRow__mLLgr`,
	"label": `QuillInput_label__pZegQ`,
	"attachPdfBtn": `QuillInput_attachPdfBtn__ZkSQE`,
	"pdfIcon": `QuillInput_pdfIcon__f1ggR`,
	"progressContainer": `QuillInput_progressContainer__LVRvJ`,
	"progressBar": `QuillInput_progressBar__NH1Ax`,
	"quillInput": `QuillInput_quillInput__nQbVJ`,
	"errorText": `QuillInput_errorText__ArVjW`,
	"configModal": `QuillInput_configModal__RUDwK`,
	"modalHeader": `QuillInput_modalHeader__2wj0E`,
	"closeBtn": `QuillInput_closeBtn__bp4GX`,
	"modalBody": `QuillInput_modalBody__yyptQ`,
	"modalFooter": `QuillInput_modalFooter__PzsY0`,
	"sectionLabel": `QuillInput_sectionLabel__Rcp0W`,
	"customInput": `QuillInput_customInput__fOR1C`,
	"optionGroup": `QuillInput_optionGroup__RoG5I`,
	"optionCard": `QuillInput_optionCard__jnm-7`,
	"alignmentGroup": `QuillInput_alignmentGroup__7+pxS`,
	"alignCard": `QuillInput_alignCard__riSrg`,
	"styleCard": `QuillInput_styleCard__SOwRh`,
	"activeOption": `QuillInput_activeOption__RrH79`,
	"actionBtnsGroup": `QuillInput_actionBtnsGroup__oCsF7`,
	"editPdfBtn": `QuillInput_editPdfBtn__+w-dL`,
	"pdfSelectBox": `QuillInput_pdfSelectBox__OfRqZ`,
	"deleteBtn": `QuillInput_deleteBtn__oDGLP`,
	"previewContainer": `QuillInput_previewContainer__rcwwP`
};
export default ___CSS_LOADER_EXPORT___;
